import { render, staticRenderFns } from "./FormQuestion.vue?vue&type=template&id=43011e0f&scoped=true"
import script from "./FormQuestion.vue?vue&type=script&lang=ts"
export * from "./FormQuestion.vue?vue&type=script&lang=ts"
import style0 from "./FormQuestion.vue?vue&type=style&index=0&id=43011e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43011e0f",
  null
  
)

export default component.exports